import { render, staticRenderFns } from "./insuranceView.vue?vue&type=template&id=761d3229&scoped=true"
import script from "./insuranceView.vue?vue&type=script&lang=js"
export * from "./insuranceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761d3229",
  null
  
)

export default component.exports